import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "aw-pardot-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScriptComponent = _resolveComponent("ScriptComponent")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "aw-form",
      style: _ctx.formVars,
      ref: "root"
    }, [
      (_ctx.config?.embed_code)
        ? (_openBlock(), _createBlock(_component_ScriptComponent, {
            value: _ctx.config?.embed_code,
            key: _ctx.config?.embed_code
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}